<div class="flex h-full flex-col">
  <!-- Grid -->
  <div class="min-h-0 flex-1">
    <app-smart-grid
      [config]="gridConfig"
      [columnDefs]="colDefs()"
      [data]="data()"
      [totalRecords]="totalItems()"
      [loading]="false"
      [pageIndex]="pageIndex()"
      (pageChanged)="onPageChange($event)"
      (sortChanged)="onSortChange($event)"
    />
  </div>
</div>
